// extracted by mini-css-extract-plugin
export default {"container":"progress-bar_container__+x9hm","segment":"progress-bar_segment__AXdu0","active":"progress-bar_active__5AffK"};